// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { LabeledInput } from 'components/Form'
import clearContactValues from './clearContactValues'
import { ContactLookupWrapper } from './styles'

const form = 'contact-lookup'
const idRoot = `${form}-`

const Form = ({ handleSubmit, error }) => {
  const dispatch = useDispatch()

  return(
    <form
      id={`${idRoot}form`}
      className={'padding-left-1 padding-right-1 heading-font'}>
      {
        error &&
        <p
          className={'width-100 bg-red'}
          id={`${idRoot}error`}>
          {error}
        </p>
      }
      <ContactLookupWrapper>
        <Field
          className={'contact-code'}
          autoFocus={true}
          component={LabeledInput}
          id={`${idRoot}contact-code`}
          label={'Contact Code'}
          name={'serviceContactCode'} />
        <Field
          className={'contact-name'}
          component={LabeledInput}
          id={`${idRoot}contact-name`}
          label={'Contact Name'}
          name={'contactName'} />
        <Field
          className={'company-name'}
          component={LabeledInput}
          id={`${idRoot}company-name`}
          label={'Company Name'}
          name={'companyName'} />
        <Field
          className={'billcode'}
          component={LabeledInput}
          id={`${idRoot}billcode`}
          label={'Billcode'}
          name={'billcode'} />
        <Field
          className={'frn'}
          component={LabeledInput}
          id={`${idRoot}frn`}
          label={'FRN'}
          name={'companyFrn'} />
        <Field
          className={'email'}
          component={LabeledInput}
          id={`${idRoot}email`}
          label={'Email'}
          name={'email'} />
        <div className={'contact-lookup-actions'}>
          <button
            className={'contact-lookup-search btn search-button'}
            id={`${idRoot}submit`}
            onClick={handleSubmit}
            type={'submit'} />
          <button
            type={'button'}
            className={'fa fa-eraser pointer clear-button'}
            id={'clearValues'}
            onClick={() => dispatch(clearContactValues(form))} />
        </div>
      </ContactLookupWrapper>
    </form>
  )
}

Form.propTypes = {
  handleSubmit: func.isRequired,
  error: string,
}

// NOTE - the form's name must come from the parent of <SearchAndSelect />
export default reduxForm({})(Form)
